export default __webpack_public_path__ + "static/media/PERP.09d601c8.webp";